<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="representativePayments.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="180"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="representativePayment"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :representative-payment="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="representativePayments.per_page"
        layout="total, prev, pager, next"
        :total="representativePayments.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'payment_date',
          order: 'ascending',
        },
      };
    },
    computed: {
      representativePayments() {
        return this.$store.getters['representativePayment/representativePayments'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['representativePayment/tableConfig']));
      },
      loading() {
        return this.$store.getters['representativePayment/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('representativePayment/setFilterString', '');
      this.$store.commit('representativePayment/setCurrentPage', this.currentPage);
      this.$store.commit('representativePayment/setSorting', this.currentSort);
      await this.$store.dispatch('representativePayment/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('representativePayment/setCurrentPage', val);
        this.$store.dispatch('representativePayment/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('representativePayment/setSorting', { prop, order });
          this.$store.dispatch('representativePayment/fetchAll');
        }
      },
    },
  };
</script>

